import { actionCreatorFactory } from 'typescript-fsa';
import {
    KintekiArrowModel,
    EntekiArrowModel,
    MakiwaraArrowModel,
} from '@app/react/3d/ArrowModelInterface';

const actionCreator = actionCreatorFactory();

export interface IFetchArrowModelParam {
    kinteki?: KintekiArrowModel;
    enteki?: EntekiArrowModel;
    makiwara?: MakiwaraArrowModel;
}

export const fetchArrowModelAction = actionCreator<IFetchArrowModelParam>(
    'fetchArrowModel',
);
